import {
  Box,
  Flex,
  HStack,
  Image,
  Text,
  VStack,
  useMediaQuery,
} from "@chakra-ui/react";

import { AppRoutes } from "src/common/constants/constantEnums";
import CONTACT_US_BG from "../../../resources/images/1682959610074-min.jpg";
import EMAIL_ICON from "../../../resources/icons/Email_Icon.svg";
import { EnglishLabels } from "src/common/constants/englishLabels";
import FACEBOOK_ICON from "../../../resources/icons/facebook-02.svg";
import { HindiLabels } from "src/common/constants/hindiLabels";
import { Link } from "react-router-dom";
import { MksLogo } from "../../../resources/icons";
import { RootState } from "src/store/store";
import X_ICON from "../../../resources/icons/x-twitter.svg";
import YOUTUBE_ICON from "../../../resources/icons/youtube.svg";
import { useCallback } from "react";
import { useSelector } from "react-redux";

interface ContactPageProps {
  hideImage?: boolean;
  scrollToAbout?: () => void;
  scrollToEvents?: () => void;
}

const facebook_link = "https://www.facebook.com/share/g/1FA8izaTZFvTpU5m/";
const youtube_link = "https://www.youtube.com/@mauryakushwahasamajthane7622";
const x_link = "https://x.com/mauryasamajthn";
const email_link = "mailto:contact@mauryasamaj.in?cc=contactmauryasamaj@gmail.com";

export const ContactPage: React.FC<ContactPageProps> = ({ hideImage }) => {
  const [isMobileOrTablet] = useMediaQuery("(max-width: 767px)");
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Flex height="100%" direction="column" background="#F8F8F8">
      <Box
        hidden={hideImage}
        width="100%"
        minH={{ base:"auto", md: "390px" }}
        py={{ base: "3rem", md: "0" }}
        color="white"
        textAlign="center"
        sx={{
          background: `linear-gradient( rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.6) ), url('${CONTACT_US_BG}')`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <VStack spacing="20px" mt={{ base: "2rem", md: "122px" }}>
          <VStack width="100%">
            <Text fontSize="32px" fontWeight="700">
              {isHindiLabels
                ? HindiLabels.Get_In_Touch_With_Us
                : EnglishLabels.Get_In_Touch_With_Us}
            </Text>
            <Text fontSize="20px" fontWeight="500">
              {isHindiLabels
                ? HindiLabels.Get_In_Touch_With_Us_Des
                : EnglishLabels.Get_In_Touch_With_Us_Des}
            </Text>
          </VStack>
          <HStack spacing="10px">
            <Box
              as="a"
              href={email_link}
              width="56px"
              height="56px"
              padding="16px"
              alignItems="center"
              borderRadius="12px"
              background="#F8F7F7"
              boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.08)"
              _hover={{
                opacity: 0.8,
                transform: "scale(1.05)",
                transition: "transform 0.3s ease, opacity 0.3s ease",
              }}
            >
              <Image src={EMAIL_ICON} />
            </Box>
            <Box
              as="a"
              href={facebook_link}
              target="_blank"
              width="56px"
              height="56px"
              padding="16px"
              alignItems="center"
              borderRadius="12px"
              background="#F8F7F7"
              boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.08)"
              _hover={{
                opacity: 0.8,
                transform: "scale(1.05)",
                transition: "transform 0.3s ease, opacity 0.3s ease",
              }}
            >
              <Image src={FACEBOOK_ICON} />
            </Box>
            <Box
              as="a"
              href={youtube_link}
              target="_blank"
              width="56px"
              height="56px"
              padding="16px"
              alignContent="center"
              borderRadius="12px"
              background="#F8F7F7"
              boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.08)"
              _hover={{
                opacity: 0.8,
                transform: "scale(1.05)",
                transition: "transform 0.3s ease, opacity 0.3s ease",
              }}
            >
              <Image src={YOUTUBE_ICON} />
            </Box>
            <Box
              as="a"
              href={x_link}
              target="_blank"
              width="56px"
              height="56px"
              padding="16px"
              alignContent="center"
              borderRadius="12px"
              background="#F8F7F7"
              boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.08)"
              _hover={{
                opacity: 0.8,
                transform: "scale(1.05)",
                transition: "transform 0.3s ease, opacity 0.3s ease",
              }}
            >
              <Image src={X_ICON} margin="auto" />
            </Box>
          </HStack>
        </VStack>
      </Box>
      {/*footer-section*/}
      <Box
        alignItems={{ base: "center", lg: "flex-start", md: "flex-start" }}
        mx={{ base: "1rem", md: "40px" }}
        mt={{ base: "3rem", md: "100px" }}
        mb="32px"
      >
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align="center"
          alignItems={{ sm: "center", lg: "flex-start", md: "flex-start" }}
          justifyContent="space-between"
        >
          <VStack
            alignItems="flex-start"
            align="start"
            mb={{ base: 6, md: 0 }}
            spacing="1rem"
          >
            <HStack>
              <Box alignItems="center" height="60px" width="60px">
                <MksLogo width={16} height="auto" />
              </Box>
              <Text
                width="195px"
                fontSize="24px"
                fontWeight="500"
                color="#4A2C2A"
              >
                {isHindiLabels
                  ? HindiLabels.Mourya_Community_Label
                  : EnglishLabels.Mourya_Community_Label}
              </Text>
            </HStack>
            <Text
              hidden={isMobileOrTablet}
              color={"#6C757D"}
              ml="1rem"
              fontSize="20px"
              fontWeight="500"
            >
              © {new Date().getFullYear()}, All rights reserved
            </Text>
          </VStack>

          <VStack
            spacing={2}
            alignItems={{ base: "center", md: "flex-start", lg: "flex-start" }}
          >
            <Text fontSize="lg" fontWeight="bold">
              {isHindiLabels
                ? HindiLabels.Quick_Links
                : EnglishLabels.Quick_Links}
            </Text>
            <Link
              className="custom-link"
              color={"#6C757D"}
              onClick={scrollToTop}
              to="/"
            >
              {isHindiLabels ? HindiLabels.Home_Page : EnglishLabels.Home_Page}
            </Link>
            <Link className="custom-link" color={"#6C757D"} to="/coming-soon">
              {isHindiLabels ? HindiLabels.Matrimony : EnglishLabels.Matrimony}
            </Link>
            <Link className="custom-link" color={"#6C757D"} to="/coming-soon">
              {isHindiLabels
                ? HindiLabels.Business_Listing
                : EnglishLabels.Business_Listing}
            </Link>
            <Link className="custom-link" color={"#6C757D"} to={AppRoutes.REGISTRATION_GUIDELINES}>
              <div>  
              {isHindiLabels ? HindiLabels.Registration_Guidelines : EnglishLabels.Registration_Guidelines}
              <span className="blinking-dot" /> 
              </div>  
            </Link>
          </VStack>

          {isMobileOrTablet ? (
            <>
              <VStack mt="1rem" alignItems="center" spacing={2}>
                <Text fontSize="lg" fontWeight="bold">
                  {isHindiLabels
                    ? HindiLabels.Social_media
                    : EnglishLabels.Social_media}
                </Text>
                <HStack spacing={4} alignItems="center">
                  <Link
                    className="custom-link"
                    color={"#6C757D"}
                    to={facebook_link}
                    target="_blank"
                  >
                    {isHindiLabels
                      ? HindiLabels.Facebook
                      : EnglishLabels.Facebook}
                  </Link>
                  <Link
                    className="custom-link"
                    color={"#6C757D"}
                    to={youtube_link}
                    target="_blank"
                  >
                    {isHindiLabels
                      ? HindiLabels.Youtube
                      : EnglishLabels.Youtube}
                  </Link>
                  <Link
                    className="custom-link"
                    color={"#6C757D"}
                    to={x_link}
                    target="_blank"
                  >
                    {isHindiLabels ? HindiLabels.X : EnglishLabels.X}
                  </Link>
                </HStack>
              </VStack>
              <VStack mt="1rem" alignItems="center" spacing={2}>
                <Text fontSize="lg" fontWeight="bold">
                  {isHindiLabels ? HindiLabels.Legal : EnglishLabels.Legal}
                </Text>
                <HStack spacing={2}>
                  <Link
                    className="custom-link"
                    color={"#6C757D"}
                    to="/privacy-policy"
                  >
                    {isHindiLabels
                      ? HindiLabels.Privacy_Policy
                      : EnglishLabels.Privacy_Policy}
                  </Link>
                  <p>|</p>
                  <Link
                    className="custom-link"
                    color={"#6C757D"}
                    to="/legal-documents"
                  >
                    {isHindiLabels
                      ? HindiLabels.Legal_Documents
                      : EnglishLabels.Legal_Documents}
                  </Link>
                </HStack>
                <Text mt={{ base: 4, md: 0 }} color={"#6C757D"}>
                  © {new Date().getFullYear()}, All rights reserved
                </Text>
              </VStack>
            </>
          ) : (
            <>
              <VStack spacing={2} alignItems="flex-start">
                <Text fontSize="lg" fontWeight="bold">
                  {isHindiLabels
                    ? HindiLabels.Social_media
                    : EnglishLabels.Social_media}
                </Text>
                <Link
                  className="custom-link"
                  color={"#6C757D"}
                  to={facebook_link}
                  target="_blank"
                >
                  {isHindiLabels
                    ? HindiLabels.Facebook
                    : EnglishLabels.Facebook}
                </Link>
                <Link
                  className="custom-link"
                  color={"#6C757D"}
                  to={youtube_link}
                  target="_blank"
                >
                  {isHindiLabels ? HindiLabels.Youtube : EnglishLabels.Youtube}
                </Link>
                <Link
                  className="custom-link"
                  color={"#6C757D"}
                  to={x_link}
                  target="_blank"
                >
                  {isHindiLabels ? HindiLabels.X : EnglishLabels.X}
                </Link>
              </VStack>

              <VStack spacing={2} alignItems="flex-start">
                <Text fontSize="lg" fontWeight="bold">
                  {isHindiLabels ? HindiLabels.Legal : EnglishLabels.Legal}
                </Text>
                <Link
                  className="custom-link"
                  color={"#6C757D"}
                  to="/privacy-policy"
                >
                  {isHindiLabels
                    ? HindiLabels.Privacy_Policy
                    : EnglishLabels.Privacy_Policy}
                </Link>
                <Link
                  className="custom-link"
                  color={"#6C757D"}
                  to="/legal-documents"
                >
                  {isHindiLabels
                    ? HindiLabels.Legal_Documents
                    : EnglishLabels.Legal_Documents}
                </Link>
              </VStack>
            </>
          )}
        </Flex>
        <Flex justifyContent={"center"} mt={{ base: 4, md: 8, lg: 12 }}>
          <HStack ml={4}>
            <Text fontSize="md" fontWeight="500">
              Powered By
            </Text>
            <Text fontSize="md" fontWeight="bold">
              VESIS
            </Text>
          </HStack>
        </Flex>
      </Box>
    </Flex>
  );
};
